import React from 'react';
import { Container } from '@nakedplatform/ui';

import { ChooseProductChatContainer } from '../chat/components/main/styles';

import { Main, MainProps } from './components/main';
import { ChooseProductStages } from './constants';

const routeContents = {
  [ChooseProductStages.main]: Main,
  [ChooseProductStages.singleItemType]: Main,
  [ChooseProductStages.singleItemValue]: Main,
};

const MOBILE_PAGE_TOP_PADDING = 30;
const TABLET_PAGE_TOP_PADDING = 40;

/**
 * Fake chat component used to show quoting calls to action to the user
 *
 * @param props - the properties of this component
 */
export function ChooseProduct(props: MultiCtaProps) {
  const { stage, ...remainingProps } = props;

  const emptyContent = () => <></>;
  const DynamicContent = routeContents[stage?.toLowerCase()] ?? emptyContent;

  return (
    <Container mt="0px">
      <ChooseProductChatContainer
        mx={['24px', '24px']}
        pt={[MOBILE_PAGE_TOP_PADDING, TABLET_PAGE_TOP_PADDING]}
      >
        <DynamicContent {...remainingProps} />
      </ChooseProductChatContainer>
    </Container>
  );
}
/**
 * Props passed to the choose product component
 */
interface MultiCtaProps extends MainProps {
  // the function to call when the component decides it needs to go back to the main multi cta page
  goToMain: () => void;
  // the current stage the multi-cta flow is in
  stage: string;
}

export { ChooseProductStages } from './constants';
